exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui.input .react-datepicker-wrapper .react-datepicker__input-container input[type='text'].transfer-order--date-picker {\n  width: 100%;\n}\n.sort-by-tittle-card {\n  padding-top: 0em;\n  margin-top: 0em !important;\n  margin-bottom: 1.3em !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/inventory/transaction/transfer/index.less
// module id = 3413
// module chunks = 0